// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__9rHkW","layout__inner":"layout_layout__inner__sbZUJ"};